import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdCoopRole } from "./info-view/IdCoopRole";
export var mapCoopRole = new Map([
    [
        IdCoopRole.Leader,
        {
            icon: IdIcon.AllianceLeaderIcn,
            loca: IdLoca.cooperativeLeader,
        },
    ],
    [
        IdCoopRole.Deputy,
        {
            icon: IdIcon.AllianceDeputyIcn,
            loca: IdLoca.deupty,
        },
    ],
    [
        IdCoopRole.Member,
        {
            icon: IdIcon.AllianceMemberIcn,
            loca: IdLoca.member,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/mapCoopRole.ts
// module id = 913
// module chunks = 3